async function postJson(url, payload = {}) {
  const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken
    },
    body: JSON.stringify(payload)
  })

  const data = await response.json().catch(() => ({}))

  if (!response.ok) {
    throw new Error(data.error || "Request failed")
  }

  return data
}

function waitForPaypal(maxAttempts = 20) {
  return new Promise((resolve, reject) => {
    let attempts = 0

    const check = () => {
      if (window.paypal) {
        resolve(window.paypal)
        return
      }

      attempts += 1

      if (attempts >= maxAttempts) {
        reject(new Error("PayPal SDK did not load."))
        return
      }

      setTimeout(check, 250)
    }

    check()
  })
}
function fieldValue(id) {
  return document.getElementById(id)?.value?.trim() || ""
}

function setDonationStatus(message, isError = false) {
  const status = document.getElementById("paypal-donation-status")
  if (!status) return

  status.textContent = message
  status.classList.toggle("text-danger", isError)
  status.classList.toggle("text-muted", !isError)
}

function donationPayload() {
  return {
    donation: {
      amount: fieldValue("donation_amount"),
      donor_first_name: fieldValue("donor_first_name"),
      donor_last_name: fieldValue("donor_last_name"),
      donor_email: fieldValue("donor_email"),
      donor_address: fieldValue("donor_address"),
      donor_city: fieldValue("donor_city"),
      donor_state: fieldValue("donor_state"),
      donor_zipcode: fieldValue("donor_zipcode"),
      note: fieldValue("donor_note")
    }
  }
}

async function setupDonationCheckout() {
  const container = document.getElementById("paypal-donation-checkout")
  if (!container) return

  if (container.dataset.initialized === "true") return
  container.dataset.initialized = "true"

//   if (!window.paypal) {
//     setDonationStatus("PayPal checkout could not load.", true)
//     return
//   }
    try {
        await waitForPaypal()
        } catch (error) {
        console.error("PayPal SDK load error:", error)
        setDonationStatus("PayPal checkout could not load.", true)
        return
        }

  const clientId = container.dataset.paypalClientId
  const createOrderUrl = container.dataset.createOrderUrl
  const captureOrderUrl = container.dataset.captureOrderUrl
  const cancelUrl = container.dataset.cancelUrl

  if (!clientId) {
    setDonationStatus("PayPal client ID is missing.", true)
    return
  }

  try {
    const sdkInstance = await window.paypal.createInstance({
      clientId: clientId,
      components: ["paypal-payments"],
      pageType: "checkout"
    })

    const paymentMethods = await sdkInstance.findEligibleMethods({
      currencyCode: "USD"
    })

    if (!paymentMethods.isEligible("paypal")) {
      setDonationStatus("PayPal checkout is not available for this donation.", true)
      return
    }

    const paypalSession = sdkInstance.createPayPalOneTimePaymentSession({
      onApprove: async (data) => {
        setDonationStatus("Capturing donation…")

        const orderId = data.orderId || data.orderID || data.id

        if (!orderId) {
          console.error("PayPal approval data did not include an order ID:", data)
          setDonationStatus("PayPal approved the donation, but no order ID was returned.", true)
          return
        }

        const result = await postJson(captureOrderUrl, {
          order_id: orderId
        })

        if (result.redirectUrl) {
          window.location.href = result.redirectUrl
        } else {
          console.error("Capture response missing redirectUrl:", result)
          setDonationStatus("Donation captured, but no success redirect was returned.", true)
        }
      },

      onCancel: () => {
        if (cancelUrl) {
          window.location.href = cancelUrl
        } else {
          setDonationStatus("Donation checkout was cancelled.", true)
        }
      },

      onError: (error) => {
        console.error("PayPal donation checkout error:", error)
        setDonationStatus("PayPal donation checkout failed. Please try again.", true)
      }
    })

    const paypalButton = container.querySelector("paypal-button")
    paypalButton.removeAttribute("hidden")

    paypalButton.addEventListener("click", async () => {
      try {
        const amount = Number(fieldValue("donation_amount"))

        if (!amount || amount < 1) {
          setDonationStatus("Please enter a donation amount of at least $1.00.", true)
          return
        }

        setDonationStatus("Opening PayPal checkout…")

        await paypalSession.start(
          { presentationMode: "auto" },
          postJson(createOrderUrl, donationPayload()).then((data) => ({
            orderId: data.orderId
          }))
        )
      } catch (error) {
        console.error("PayPal donation start error:", error)
        setDonationStatus(error.message || "Could not start PayPal donation checkout.", true)
      }
    })

    setDonationStatus("PayPal checkout is ready.")
  } catch (error) {
    console.error("PayPal donation setup error:", error)
    setDonationStatus("PayPal donation checkout setup failed.", true)
  }
}

document.addEventListener("turbo:load", setupDonationCheckout)